import { FC } from 'react'
import { useDrag } from 'react-dnd'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { nodeIcon } from '../../../../utils/constants'

import styles from './styles.module.scss'

interface IProps {
  type: string
  name: string
  description: string
  icon: string
}

/*
 * Used to choose new nodes from the left nav, not used to draw nodes in the playbook.
 *
 * TODO: Perhaps we could consolidate?
 */
const NodeItem: FC<IProps> = ({ icon, type, name, description }) => {
  const theme = useTheme()

  const [, drag] = useDrag(() => ({
    type: 'draggableItem',
    item: { type },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }))

  const NodeIcon = nodeIcon({ icon })

  return (
    <Box
      ref={drag}
      className={styles.nodeItem}
      sx={{
        border: '1px solid ' + theme.palette.elevated.dark,
        background: theme.palette.elevated.main,
      }}
      draggable
    >
      <Box className={styles.iconContainer}>
        <NodeIcon
          sx={{ color: theme.palette.primary.main, width: 32, height: 32 }}
        />
        <Box>
          <Typography className={styles.text}>{name}</Typography>
          <Typography
            className={styles.description}
            sx={{ color: theme.palette.text.disabled }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
      <DragIndicatorIcon className={styles.dragIcon} />
    </Box>
  )
}

export default NodeItem
